// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { StyledTypography } from "@insite/mobius/Link";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import CaretRight from "@werner/XDL/Icons/CaretRight";
import { fontConfig } from "@werner/XDL/PreStyle/typography";
import { xBaseTheme } from "@werner/XDL/types";
import color, { getSystemColor } from "@werner/XDL/Utilities/color";
import { css } from "styled-components";

const secondaryVariant = css`
    &,
    & ${TypographyStyle}, & ${IconWrapper} {
        color: ${color("common.ui3")};
    }
    &:hover {
        &,
        & ${TypographyStyle}, & ${IconWrapper} {
            color: ${color("primary")};
        }
    }
`;

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        mergeCss: true,
        color: "text.link",
        hoverStyle: {
            color: getSystemColor("common.ui3"),
        },
        typographyProps: {
            mergeCss: true,
            size: 16,
            weight: 500,
            css: css`
                letter-spacing: 0;
                line-height: 30px;
            `,
        },
        css: css`
            transition: all ${getProp("theme.transition.duration.regular", "300")}ms ease-in-out;

            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
            ${({ _color }: any) => {
                if (_color === "secondary") {
                    return secondaryVariant;
                }
            }}
        `,
    },
} as xBaseTheme["link"];
